import imgLock from "../assets/images/imag-orientation-lock.png";
import styled from "styled-components";

export default function OrientationLock() {
  return (
    <Container>
      <div id="orientation-lock-container">
        <img src={imgLock} alt="img-log" className="img-lock"/>
      </div>
    </Container>
  );
}

const Container = styled.div`
  #orientation-lock-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: white;
    color: #fff;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18;
    text-align: center;
    padding: 20px;

    .img-lock{
      max-height: 100%;
    }
  }

  @media (max-width: 991.98px) {
    display: none;
  }

  @media (min-height: 666.98px) {
    display: none;
  }

  @media screen and (max-height: 431px) and (min-width: 667px) {
    display: block;
  }

  @media (min-width: 1200px) {
    display: none;
  }
`;
